import {
    AUTH_FETCH,
    AUTH_IS_FETCING,
    // AUTH_API,
} from 'constants/auth'

//HTTP reuests actions
import { auth } from 'actions/requests'

export const authLogin = (login, password) => (dispatch) => {
    dispatch(authIsFetching(true))
    return auth(login, password)
        .then((e) => {
            dispatch(authFetched(e))
            return e;
        })
        .finally(() => dispatch(authIsFetching(false)))
}
export const authFetched = (payload) => ({ type: AUTH_FETCH, payload: payload })
export const authIsFetching = (payload) => ({ type: AUTH_IS_FETCING, payload: payload })


// WEBPACK FOOTER //
// ./src/actions/auth.js